import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class SchemaUiService {

  constructor() {}

  getShortSchemaName(schemaName: string) {
    const name = schemaName?.trim();

    const words = name.split(/\s+/).filter((w) => w.length > 0);

    if (words.length > 1) {
      //? Més d'una paraula, char inicial de cadascuna
      return words
        .map((w) => w[0])
        .join('')
        .toUpperCase();
    } else {
      //? Una paraula, 3 primers chars
      return name.substring(0, 3).toUpperCase();
    }
  };
}